<template>
  <div style="width: 100%">
    <table style="width: 100%">
      <thead>
        <tr>
          <td>
            <div class="header-space print">
              &nbsp;
            </div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div>
              <div class="pa-4 print__container">
                <div>
                  <h1 class="mb-3">
                    Звіт з залишку невикористаних коштів на Передплатному
                    балансі Замовника
                  </h1>
                  <table>
                    <tr v-if="filter.client">
                      <td class="pb-1 body-2">
                        Замовник:
                      </td>
                      <td class="subtitle-1 pl-2 font-weight-bold">
                        {{ filter.client.title }}
                      </td>
                    </tr>
                    <tr>
                      <td class="body-2">
                        Період:
                      </td>
                      <td class="subtitle-1 pl-2 font-weight-bold">
                        {{ filter.dateFrom | monthYear }} -
                        {{ filter.dateTo | monthYear }}
                      </td>
                    </tr>
                  </table>
                </div>
                <div>
                  <div>
                    <h2 class="text-center my-4">
                      Передплатний баланс Замовника
                    </h2>
                    <table
                      width="100%"
                      class="table-style my-2"
                    >
                      <thead>
                        <tr>
                          <th
                            class="row-colomn-style text-left"
                            width="100"
                          >
                            Місяць/рік
                          </th>
                          <th class="row-colomn-style">
                            На початок місяця, год
                          </th>
                          <th class="row-colomn-style">
                            Оплата Послуг, год
                          </th>
                          <th class="row-colomn-style">
                            Надані Послуги, год
                          </th>
                          <th
                            v-if="!hideServiceHoursColumn"
                            class="row-colomn-style"
                          >
                            Сервіси
                          </th>
                          <th
                            v-if="totalBonusHours > 0"
                            class="row-colomn-style"
                          >
                            Бонуси, год.
                          </th>
                          <th class="row-colomn-style">
                            На кінець місяця, год
                          </th>
                        </tr>
                      </thead>
                      <tbody
                        v-for="item in items"
                        :key="item.key"
                      >
                        <tr>
                          <td
                            class="row-colomn-style text-left"
                            width="120px"
                          >
                            {{ item.month }}
                          </td>
                          <td
                            class="row-colomn-style"
                            :class="{ 'red--text': item.startMonthBalance < 0 }"
                          >
                            {{ item.startMonthBalance | decimal }}
                          </td>
                          <td
                            class="row-colomn-style"
                            :class="{ 'red--text': item.payedHours < 0 }"
                          >
                            {{ item.payedHours | decimal }}
                          </td>
                          <td
                            class="row-colomn-style"
                            :class="{ 'red--text': item.payedHours < 0 }"
                          >
                            {{ item.spentHours | decimal }}
                          </td>
                          <td
                            v-if="!hideServiceHoursColumn"
                            class="row-colomn-style"
                            :class="{ 'red--text': item.servicesHours < 0 }"
                          >
                            {{ item.servicesHours | decimal }}
                          </td>
                          <td
                            v-if="totalBonusHours > 0"
                            class="row-colomn-style"
                          >
                            {{ item.bonusHours | decimal }}
                          </td>
                          <td
                            class="row-colomn-style"
                            :class="{ 'red--text': item.endMonthBalance < 0 }"
                          >
                            {{ item.endMonthBalance | decimal }}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr class="font-weight-bold">
                          <td
                            class="row-colomn-style text-left"
                            colspan="2"
                          >
                            Разом:
                          </td>
                          <td
                            class="row-colomn-style"
                            :class="{ 'red--text': totalPayedHours < 0 }"
                          >
                            {{ totalPayedHours | decimal }}
                          </td>
                          <td
                            class="row-colomn-style"
                            :class="{ 'red--text': totalSpentHours < 0 }"
                          >
                            {{ totalSpentHours | decimal }}
                          </td>
                          <td
                            v-if="!hideServiceHoursColumn"
                            class="row-colomn-style"
                            :class="{ 'red--text': totalServicesHours < 0 }"
                          >
                            {{ totalServicesHours | decimal }}
                          </td>
                          <td
                            v-if="totalBonusHours > 0"
                            class="row-colomn-style"
                          >
                            {{ totalBonusHours | decimal }}
                          </td>
                          <td
                            class="row-colomn-style"
                            :class="{ 'red--text': totalEndMonthBalance < 0 }"
                          >
                            {{ totalEndMonthBalance | decimal }}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>
            <div class="footer-space print">
              &nbsp;
            </div>
          </td>
        </tr>
      </tfoot>
    </table>
    <div class="pageHeader print">
      <img
        src="../../../../public/logo.png"
        width="150px"
      >
    </div>
    <div class="pageFooter print">
      <v-divider />
      <table>
        <tr>
          <td width="100%">
            {{ `Звіт сформовано: ${dateNow} р.` }}
          </td>
          <td width="100%">
            <img
              class="ml-3 mt-2"
              src="../../../../public/pageFooter.png"
            >
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => ([]),
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
    totalStartMonthBalance: {
      type: Number,
      default: 0,
    },
    totalPayedHours: {
      type: Number,
      default: 0,
    },
    totalSpentHours: {
      type: Number,
      default: 0,
    },
    totalBonusHours: {

    },
    totalEndMonthBalance: {
      type: Number,
      default: 0,
    },
    totalServicesHours: {
      type: Number,
      default: 0,
    },
    hideServiceHoursColumn: {
      type: Boolean,
      default: false,
    },
  },
  date() {
    return {
      dateNow: null,
    };
  },
  created() {
    const now = Date.now();
    this.dateNow = this.moment(now).format("hh:mm YYYY");
  },
};
</script>

<style>
.pageHeader,
.header-space,
.pageFooter,
.footer-space {
  height: 50px;
}
.print {
  display: none;
}
.pageHeader {
  position: fixed;
  top: 0;
  right: 0;
}
.pageFooter {
  position: fixed;
  bottom: 0;
}
</style>
